import React from 'react';

import { Text } from '@blueprint/text';
import { Card } from '@blueprint/card';
import { BedSmall, PriceSmall, AreaSmall, CarSmall } from '@blueprint/icons';

import { currencyFormatter } from 'shared/helpers/currencyFormatter';
import { GardenSvg } from 'shared/components/GardenSvg/GardenSvg';

import {
    DevelopmentOptionsContainer,
    DevelopmentOptionsWrapper,
    List,
    ListItem,
    Name
} from './DevelopmentOptions.styles';

import type { Props } from './DevelopmentOptions.types';

const DevelopmentOptions: React.FC<Props> = ({
    bedrooms,
    helpToBuy,
    sharedOwnership,
    minimumPlotPrice,
    hasOnlyPriceOnAsk,
    listings
}) => {
    listings = listings || [];

    const comingSoon: boolean =
        !minimumPlotPrice || minimumPlotPrice === 0 || !!hasOnlyPriceOnAsk;

    const showPrice: boolean =
        !!minimumPlotPrice && minimumPlotPrice > 0 && !hasOnlyPriceOnAsk;

    const sortedListings = [...listings].sort((a, b) => {
        if (!a?.floorArea?.value) return 0;
        if (!b?.floorArea?.value) return 0;

        return a?.floorArea?.value - b?.floorArea?.value;
    });

    const hasOutdoorSpace = (listings || []).some(
        (i) => i?.balcony || i?.garden || i?.terrace
    );

    const hasParking = listings.some((i) => i?.parking);
    const hasGarage = listings.some((i) => i?.garage);

    const sqFootage = sortedListings[0]?.floorArea?.label;

    const pricesFrom = 'Price starting from';
    const pricesComingSoon = 'Prices coming soon';

    return (
        <>
            <DevelopmentOptionsWrapper>
                <Text isBold size="7">
                    Available in this development{' '}
                </Text>
                <DevelopmentOptionsContainer>
                    <List>
                        {!!bedrooms && (
                            <ListItem data-testid="development-list-item">
                                <BedSmall data-testid="beds" />
                                <Name>{bedrooms}</Name>
                            </ListItem>
                        )}

                        <ListItem data-testid="development-list-item">
                            <PriceSmall data-testid="price" />
                            <Name>
                                {comingSoon ? pricesComingSoon : pricesFrom}{' '}
                                {showPrice
                                    ? currencyFormatter.format(
                                          minimumPlotPrice || 0
                                      )
                                    : ''}{' '}
                            </Name>
                        </ListItem>

                        {(helpToBuy || sharedOwnership) && (
                            <ListItem data-testid="development-list-item">
                                <PriceSmall data-testid="schemes" />
                                <Name>Buying schemes available</Name>
                            </ListItem>
                        )}

                        {!!sqFootage && (
                            <ListItem data-testid="development-list-item">
                                <AreaSmall data-testid="sq-footage" />
                                <Name>Starting from {sqFootage}</Name>
                            </ListItem>
                        )}

                        {hasOutdoorSpace && (
                            <ListItem data-testid="development-list-item">
                                <GardenSvg data-testid="outdoor-space" />
                                <Name>Outdoor space</Name>
                            </ListItem>
                        )}

                        {(hasParking || hasGarage) && (
                            <ListItem data-testid="development-list-item">
                                <CarSmall data-testid="parking" />
                                <Name>
                                    {hasParking && hasGarage
                                        ? 'Garage / Parking'
                                        : hasParking
                                        ? 'Parking'
                                        : 'Garage'}
                                </Name>
                            </ListItem>
                        )}
                    </List>
                    <List>
                        <Card>Card Box</Card>
                    </List>
                </DevelopmentOptionsContainer>
            </DevelopmentOptionsWrapper>
        </>
    );
};

export default DevelopmentOptions;
